export const USER_SETTINGS_BY_PAGE_STORAGE_KEY = 'userSettings';
export const USER_SETTINGS_BY_USER_STORAGE_KEY = 'userSettingsByUser';
export const UNIFIED_API_URL_KEY = 'unified-api-url';

export const ADS_MANAGER_IS_CAMPAIGN_CREATED_LOCAL_STORAGE_KEY = 'adsManagerIsCampaignCreated';
export const INVENTORY_INSIGHTS_SUCCESS_MODAL_STORAGE_KEY = 'mpfe_inventory_insights_success_modal';
export const COMPLIANCE_BT_AUTH_STORAGE_KEY = 'complianceBioTrackAuth';
